import React, { FC } from 'react'

interface Props {
  value: number | null
}

const BarGraphBase: FC<Props> = (props) => {
  const {
    value,
  } = props

  return (
    <>
      <div className="graph_area">
        <div
          className="graph"
          style={{
            width: `${value}%`,
          }}
        />
        <div className="delimiter">
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
        </div>
      </div>
    </>
  )
}

export default BarGraphBase
